<template>
  <div v-if="data" class="pay-success">
    <!-- 支付结果图标 -->
    <div :class="['pay-success-icon', { 'pay-error': !isSuccess }]">
      <i :class="isSuccess ? 'icon-success' : 'icon-error'"></i>
    </div>

    <!-- 支付结果标题 -->
    <div :class="['pay-success-title', { 'pay-error': !isSuccess }]">
      {{ isSuccess ? '支付成功' : '支付失败' }}
    </div>

    <!-- 商户名称 -->
    <div class="pay-success-subtitle">{{ data.merchantName }}</div>

    <!-- 支付金额（仅成功时显示） -->
    <div v-if="isSuccess" class="pay-success-amount">¥{{ data.payAmount }}</div>

    <!-- 支付状态信息 -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="pay-success-subtitle" v-html="data.payStatusMsg"></div>

    <!-- 优惠信息分割线 -->
    <div v-if="couponInfo.length > 0" class="pay-success-divide"></div>

    <!-- 优惠信息 -->
    <div v-if="couponInfo.length > 0" class="pay-success-coupon">
      <div class="coupon-item original">
        <span class="coupon-label">原价</span>
        <span class="coupon-value">¥{{ data.originAmount }}</span>
      </div>
      <div v-for="(coupon, index) in couponInfo" :key="index" class="coupon-item">
        <span class="coupon-label">{{ coupon.offDesc }}</span>
        <span class="coupon-value discount">-¥{{ coupon.offAmt }}</span>
      </div>
    </div>

    <!-- 完成/重新支付按钮 -->
    <div class="pay-success-button">
      <button class="btn-primary" @click="onFinish">
        {{ isSuccess ? '完成' : '重新支付' }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PaySuccess',
  props: {
    payResultInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: null,
    }
  },
  computed: {
    // 判断支付是否成功
    isSuccess() {
      if (!this.data) return false
      switch (this.data.payStatus) {
        case '0': // 交易成功
        case '50': // 主扫成功
        case '52': // 扣款成功但未通知银联
          return true
        case '8':
        case '9':
        case '53': // 扣款成功但银联表示失败
        case '56': // 账户扣款失败
        case '57': // 任何其他支付失败的情况
        default:
          return false
      }
    },

    // 判断是否主扫支付
    isScanPay() {
      if (!this.data) return false
      return Number(this.data.payStatus) >= 50
    },

    // 处理优惠信息
    couponInfo() {
      if (!this.data) return []

      let promotion = []
      try {
        // 解析 mtPromotion JSON 字符串
        if (this.data.mtPromotion) {
          promotion = JSON.parse(this.data.mtPromotion)
        }
      } catch (e) {
        console.warn('Failed to parse mtPromotion:', e)
      }

      const info = Array.isArray(promotion) ? promotion : []

      // 如果有单个优惠券，追加到列表
      if (this.data.couponAmount) {
        info.push({
          type: 99,
          offAmt: this.data.couponAmount,
          offDesc: this.data.couponDesc,
        })
      }

      return info
    },
  },
  created() {
    // 从 props 获取支付结果数据
    this.data = this.payResultInfo
    console.log('🔍 [PaySuccess] payResultInfo:', this.payResultInfo)
    console.log('🔍 [PaySuccess] this.data:', this.data)

    // 上报页面 PV
    if (this.data && this.data.payStatus) {
      this.$lx.paySuccessPagePV({
        custom: {
          pay_type: this.isScanPay ? 1 : 0,
          pay_status: this.data.payStatus,
          project_name: 'union-pay-qrcode'
        },
      })
    }
  },
  methods: {
    // 完成支付或重新支付
    onFinish() {
      if (this.isSuccess) {
        this.handleSuccess()
      } else {
        this.handleError()
      }
    },

    // 处理支付成功
    handleSuccess() {
      // 返回付款码页面
      this.$parent.backToPayPage()
    },

    // 处理支付失败
    handleError() {
      // 返回付款码页面
      this.$parent.backToPayPage()
    },
  },
}
</script>

<style lang="less" scoped>
@import '../assets/variable.less';

// 颜色定义
@success-color: #58c38b;
@error-color: #f36968;
@text-gray: #555555;
@border-color: #e5e5e5;
@discount-color: #ff6000;

.pay-success {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 20px;
  text-align: center;

  &-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;

    i {
      display: block;
    }

    &:not(.pay-error) i {
      color: @success-color;
    }

    &.pay-error i {
      color: @error-color;
    }
  }

  &-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
    color: @success-color;
    line-height: 28px;

    &.pay-error {
      color: @error-color;
    }
  }

  &-subtitle {
    font-size: 14px;
    color: @text-gray;
    line-height: 20px;
    margin-bottom: 8px;
  }

  &-amount {
    font-size: 20px;
    font-weight: 500;
    color: #111111;
    margin: 12px 0 8px;
    line-height: 28px;
  }

  &-divide {
    width: calc(100% - 72px);
    height: 1px;
    background: @border-color;
    margin: 12px 36px;
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: -2px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: @border-color;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  &-coupon {
    width: 100%;
    padding: 8px 36px;
    font-size: 13px;
    color: @text-gray;
    text-align: left;
    line-height: 1.8;

    .coupon-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 0;

      &.original {
        .coupon-value {
          text-decoration: line-through;
          color: @text-gray;
        }
      }

      .coupon-label {
        flex: 1;
        text-align: left;
      }

      .coupon-value {
        text-align: right;
        color: #111111;

        &.discount {
          color: @discount-color;
        }
      }
    }
  }

  &-button {
    width: 100%;
    padding: 0 20px;
    margin-top: 20px;

    button {
      width: 100%;
      height: 44px;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &:active {
        opacity: 0.8;
      }
    }
  }

  .btn-primary {
    background: #ffd100;
    color: #111111;
  }

  .btn-secondary {
    background: #ffffff;
    color: #31bcad;
    border: 1px solid #f0f0f0;

    i {
      display: inline-block;
      transform: rotate(180deg);
      font-size: 12px;
    }
  }
}

// 使用 flex-center 混合
.flex-center(@justify: center) {
  display: flex;
  justify-content: @justify;
  align-items: center;
}
</style>
